import { Controller } from '@hotwired/stimulus'

export default class HelperController extends Controller {
  static targets = ['emojiShow']

  connect() {}

  emojiShowTargetConnected(element) {
    const ql = $(element).find('.ql-emoji')
    ql.css('background-image', `url('${ql.data('url')}')`)
    ql.css('position', 'relative')
    ql.css('background-repeat', 'no-repeat')
  }
}
